import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Client, ClientInput, ClientNote } from "@plataforma/shared";
import { api, queryString } from "../../lib/api";

export const useClients = (query = "") => useQuery({ queryKey: ["clients", query], queryFn: async () => (await api.get<{ clients: Client[] }>(`/clients${queryString({ q: query })}`)).clients, placeholderData: (previous) => previous });

export const useClient = (id: string | undefined) => useQuery({ queryKey: ["client", id], enabled: Boolean(id), queryFn: () => api.get<{ client: Client; notes: ClientNote[] }>(`/clients/${id}`) });

export function useSaveClient(id?: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: ClientInput) => (id ? await api.put<{ client: Client }>(`/clients/${id}`, input) : await api.post<{ client: Client }>("/clients", input)).client,
    onSuccess: () => Promise.all([queryClient.invalidateQueries({ queryKey: ["clients"] }), queryClient.invalidateQueries({ queryKey: ["client"] }), queryClient.invalidateQueries({ queryKey: ["appointments"] })]),
  });
}

export function useAddNote(clientId: string) {
  const queryClient = useQueryClient();
  return useMutation({ mutationFn: (text: string) => api.post(`/clients/${clientId}/notes`, { text }), onSuccess: () => queryClient.invalidateQueries({ queryKey: ["client", clientId] }) });
}
